// TODO: remove once Hasura is updated or come up with a more resilient option
// translates "YYYY-mm-dd HH:mm:ss.mmm" to "YYYY-mm-ddTHH:mm:ss.mmmZ"
export const convertDateTimeToISO = (x: string) => {
  const ensuredT = x.replace(' ', 'T');
  return ensuredT.endsWith('Z') ? ensuredT : `${ensuredT}Z`;
};
